module.exports = __webpack_public_path__ + "img/File.b65fa292.svg";